var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6413 47.265L48.8587 54.1838C48.8587 54.1838 63.3225 57.255 63.3225 64.56C63.3225 69.75 56.8875 69.75 56.8875 69.75H39.75L31.3125 65.0625",
    stroke: "#585864",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3587 47.265L23.145 54.1838C23.145 54.1838 8.67749 57.255 8.67749 64.56C8.67749 69.75 15.1125 69.75 15.1125 69.75H22.875L31.3125 65.0625L41.625 58.5",
    stroke: "#585864",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 50.7225C2.25 50.7225 10.2862 48.9937 15.1087 47.265C19.9275 23.0475 34.3875 24.7762 36 24.7762C37.6087 24.7762 52.0725 23.0475 56.8912 47.265C61.7137 48.99 69.75 50.7225 69.75 50.7225M36 17.25C37.9891 17.25 39.8968 16.4598 41.3033 15.0533C42.7098 13.6468 43.5 11.7391 43.5 9.75C43.5 7.76088 42.7098 5.85322 41.3033 4.4467C39.8968 3.04018 37.9891 2.25 36 2.25C34.0109 2.25 32.1032 3.04018 30.6967 4.4467C29.2902 5.85322 28.5 7.76088 28.5 9.75C28.5 11.7391 29.2902 13.6468 30.6967 15.0533C32.1032 16.4598 34.0109 17.25 36 17.25Z",
    stroke: "#585864",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.3425a9d8ff398ca2a89b61fc367a709c.svg";
export { ForwardRef as ReactComponent };